import React from 'react';

import '../footer.css';

export function Footer() {
  return (
    <div className="global-footer global-footer--alumni">
      <div className="content">
        <div className="x_footer_lines">
          <div className="x_footer_cols">
            <div className="x_footer_contact">
              <div className="global-logo global-logo--footer">
                <div className="x_footer_logo w-embed">
                  <svg className="x_footer_logo" xmlns="http://www.w3.org/2000/svg" width={181} height={20}>
                    <path d="M163.5.499c0-.277.245-.499.514-.499h.678l11.261 12.278h.029V.805c0-.277.216-.528.514-.528h2.49a.54.54 0 0 1 .514.528v18.696c0 .277-.243.499-.514.499h-.649L167.02 7.249h-.029v11.946c0 .277-.216.528-.514.528h-2.463c-.269 0-.514-.25-.514-.528V.499zm-23.015 15.889c3.506 0 6.398-2.86 6.398-6.36s-2.891-6.417-6.398-6.417-6.37 2.917-6.37 6.417 2.867 6.36 6.37 6.36m0-16.389A9.99 9.99 0 0 1 150.5 10.028c0 5.555-4.452 9.972-10.015 9.972s-9.985-4.416-9.985-9.972S134.922 0 140.485 0M97.854.417c.028-.222.195-.417.504-.417h.451c.224 0 .392.111.476.277l6.183 13.112h.082L111.734.277c.085-.167.225-.277.476-.277h.452a.47.47 0 0 1 .504.417l3.317 18.667c.082.388-.142.639-.506.639h-2.557c-.254 0-.479-.222-.534-.417l-1.659-10.528h-.085l-4.916 10.916c-.057.168-.224.306-.479.306h-.506c-.252 0-.392-.138-.476-.306L99.792 8.778h-.085l-1.629 10.528c-.03.195-.254.417-.506.417h-2.529c-.364 0-.591-.25-.534-.639L97.854.417zM72.485 16.389c3.505 0 6.399-2.86 6.399-6.36a6.46 6.46 0 0 0-6.399-6.417c-3.504 0-6.369 2.917-6.369 6.417s2.866 6.36 6.369 6.36m0-16.389C78.049 0 82.5 4.472 82.5 10.028S78.049 20 72.485 20 62.5 15.584 62.5 10.028 66.922 0 72.485 0M32.5.499c0-.277.244-.499.514-.499h.678l11.262 12.278h.026V.805c0-.277.216-.528.514-.528h2.491a.54.54 0 0 1 .514.528v18.696c0 .277-.243.499-.514.499h-.65L36.02 7.249h-.027v11.946c0 .277-.216.528-.514.528h-2.465a.54.54 0 0 1-.514-.528V.499zM10.423 0c2.488 0 4.866.973 6.746 2.586.221.222.249.557.028.779l-1.714 1.809c-.222.222-.47.222-.719 0C13.575 4.116 12.11 3.56 10.59 3.56c-3.456 0-6.192 2.977-6.192 6.453 0 3.449 2.736 6.371 6.219 6.371 1.548 0 2.737-.473 3.289-.697v-2.364h-2.211c-.304 0-.525-.222-.525-.5v-2.197a.51.51 0 0 1 .525-.528h5.308c.276 0 .497.249.497.528v7.121c0 .222-.11.362-.221.444 0 0-2.846 1.809-6.856 1.809C4.923 20 .5 15.605.5 10.042S4.923 0 10.423 0" fillRule="evenodd" fill="currentColor" />
                  </svg>
                </div>
              </div>
              <div className="x_footer_contact x_footer_contact--c">
                <div className="x_footer_nav">
                  <a target="_blank" href="https://www.gnomon.edu/academics/foundation-in-art-and-design/" className="x_footer_link_li">Email | info@gnomon.edu<br />Phone | 323.466.6663<br />Fax | 323.466.6710</a>
                </div>
                <div className="x_footer_nav">
                  <a target="_blank" href="https://www.gnomon.edu/academics/foundation-in-art-and-design/" className="x_footer_link_li">6150 Laurel Canyon Blvd.<br />North Hollywood, CA 91606</a>
                </div>
                <div className="x_footer_nav">
                  <div className="x_footer_link_li">
                    <div>
                      <a target="_blank" href="https://www.gnomon.edu/academics/foundation-in-art-and-design/" className="x_footer_link_li">Contact Us</a>
                    </div>
                  </div>
                  <div className="x_footer_link_li">
                    <div>
                      <a target="_blank" href="https://www.gnomon.edu/academics/foundation-in-art-and-design/" className="x_footer_link_li">Press Page</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="x_footer_right">
              <div className="x_footer_right_cols">
                <div className="x_footer_nav">
                  <div className="x_footer_sub-title">
                    <div>Tools &amp; Resources</div>
                  </div>
                  <div className="x_footer_links">
                    <div className="x_footer_link_li">
                      <div>
                        <a target="_blank" href="https://www.gnomon.edu/academics/foundation-in-art-and-design/" className="x_footer_link_li">Online Classes Login</a>
                      </div>
                    </div>
                    <div className="x_footer_link_li">
                      <div>
                        <a target="_blank" href="https://www.gnomon.edu/academics/foundation-in-art-and-design/" className="x_footer_link_li">Student Portal</a>
                      </div>
                    </div>
                    <div className="x_footer_link_li">
                      <div>
                        <a target="_blank" href="https://www.gnomon.edu/academics/foundation-in-art-and-design/" className="x_footer_link_li">Academic Calendar</a>
                      </div>
                    </div>
                    <div className="x_footer_link_li">
                      <div>
                        <a target="_blank" href="https://www.gnomon.edu/academics/foundation-in-art-and-design/" className="x_footer_link_li">Student Catalog</a>
                      </div>
                    </div>
                    <div className="x_footer_link_li">
                      <div>
                        <a target="_blank" href="https://www.gnomon.edu/academics/foundation-in-art-and-design/" className="x_footer_link_li">Net Price Calculator</a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="x_footer_nav">
                  <div className="x_footer_sub-title">
                    <div>Information</div>
                  </div>
                  <div className="x_footer_links">
                    <div className="x_footer_link_li">
                      <div>
                        <a target="_blank" href="https://www.gnomon.edu/academics/foundation-in-art-and-design/" className="x_footer_link_li">Policies &amp; Disclosures</a>
                      </div>
                    </div>
                    <div className="x_footer_link_li">
                      <div>
                        <a target="_blank" href="https://www.gnomon.edu/academics/foundation-in-art-and-design/" className="x_footer_link_li">Student Right to Know</a>
                      </div>
                    </div>
                    <div className="x_footer_link_li">
                      <div>
                        <a target="_blank" href="https://www.gnomon.edu/academics/foundation-in-art-and-design/" className="x_footer_link_li">Join the Mailing List</a>
                      </div>
                    </div>
                    <div className="x_footer_link_li">
                      <div>
                        <a target="_blank" href="https://www.gnomon.edu/academics/foundation-in-art-and-design/" className="x_footer_link_li">FAQ's</a>
                      </div>
                    </div>
                    <div className="x_footer_link_li">
                      <div>
                        <a target="_blank" href="https://www.gnomon.edu/academics/foundation-in-art-and-design/" className="x_footer_link_li">Employment</a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="x_footer_nav">
                  <div className="x_footer_sub-title">
                    <div>Areas of Study</div>
                  </div>
                  <div className="x_footer_links">
                    <div className="x_footer_link_li">
                      <div>
                        <a target="_blank" href="https://www.gnomon.edu/academics/foundation-in-art-and-design/" className="x_footer_link_li">Foundation in Art &amp; Design</a>
                      </div>
                    </div>
                    <div className="x_footer_link_li">
                      <div>
                        <a target="_blank" href="https://www.gnomon.edu/academics/foundation-in-art-and-design/" className="x_footer_link_li">3D Generalist</a>
                      </div>
                    </div>
                    <div className="x_footer_link_li">
                      <div>
                        <a target="_blank" href="https://www.gnomon.edu/academics/foundation-in-art-and-design/" className="x_footer_link_li">Modeling &amp; Texturing</a>
                      </div>
                    </div>
                    <div className="x_footer_link_li">
                      <div>
                        <a target="_blank" href="https://www.gnomon.edu/academics/foundation-in-art-and-design/" className="x_footer_link_li">Character &amp; Creature Animation</a>
                      </div>
                    </div>
                    <div className="x_footer_link_li">
                      <div>
                        <a target="_blank" href="https://www.gnomon.edu/academics/foundation-in-art-and-design/" className="x_footer_link_li">VFX Animation</a>
                      </div>
                    </div>
                    <div className="x_footer_link_li">
                      <div>
                        <a target="_blank" href="https://www.gnomon.edu/academics/foundation-in-art-and-design/" className="x_footer_link_li">Games</a>
                      </div>
                    </div>
                    <div className="x_footer_link_li">
                      <div>
                        <a target="_blank" href="https://www.gnomon.edu/academics/foundation-in-art-and-design/" className="x_footer_link_li">Virtual Production</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="x_footer_cols">
            <div className="x_footer_contact">
              <div className="x_contact_social0">
                <div className="x_contact_social_icons">
                  <div className="w-embed">
                    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20}>
                      <path fill="currentColor" fillRule="evenodd" d="M20 10c0-5.523-4.477-10-10-10S0 4.477 0 10c0 4.99 3.657 9.128 8.438 9.88V12.89h-2.54V10h2.54V7.797c0-2.506 1.493-3.89 3.777-3.89a15.38 15.38 0 0 1 2.238.195v2.46h-1.26c-1.242 0-1.63.77-1.63 1.562V10h2.773l-.443 2.89h-2.33v6.988C16.343 19.128 20 14.99 20 10" />
                    </svg>
                  </div>
                  <div className="w-embed">
                    <svg xmlns="http://www.w3.org/2000/svg" width={22} height={20}>
                      <path fill="currentColor" fillRule="evenodd" d="M20 3.333C20.533 2.667 21.067 2 21.2 1.2c.133-.133-.133-.4-.267-.267-.8.533-1.467.8-2.267 1.067H18.4c-.133 0-.267-.133-.4-.133-.8-.8-1.867-1.2-3.067-1.2-.533 0-.933 0-1.467.133C12 1.333 10.8 2.667 10.4 4.133c-.133.667-.133 1.2-.133 1.867v.133h-.133c-3.333-.267-6.4-2-8.533-4.667 0-.133-.267 0-.4.133C.8 2.267.667 3.067.667 4c0 1.333.4 2.533 1.333 3.333-.4 0-.667-.133-1.067-.4-.133 0-.4 0-.4.267 0 1.867 1.2 3.6 2.8 4.4H3.2c-.267 0-.533 0-.8-.133-.133 0-.267.267-.267.4.533 1.733 2 2.933 3.733 3.2-1.467 1.067-3.067 1.6-4.8 1.6H.533c-.267 0-.4.133-.4.267s0 .267.133.4c2 1.2 4.267 1.733 6.533 1.733 2 0 3.867-.4 5.467-1.2 1.6-.667 2.933-1.733 4.133-3.067 1.067-1.2 1.867-2.667 2.4-4.267.533-1.467.8-3.067.8-4.667h0c0-.267.133-.533.4-.667.667-.533 1.333-1.333 1.867-2.133.133-.133-.133-.4-.4-.267-.4.133-.933.4-1.467.533z" />
                    </svg>
                  </div>
                  <div className="w-embed">
                    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20}>
                      <path fill="currentColor" d="M18.443 0c.81 0 1.467.641 1.467 1.431v17.114c0 .79-.657 1.431-1.467 1.431H1.527c-.81 0-1.467-.641-1.467-1.43V1.431C.06.641.717 0 1.527 0h16.916zM6.077 7.701H3.079v9.02h2.998v-9.02zm7.36-.211c-1.54 0-2.258.82-2.663 1.43l-.039.058.001-1.276H7.737l.017 1.883v1.275.548l-.017 5.313h2.998v-5.037c0-.269.02-.539.099-.731.217-.539.71-1.097 1.538-1.097 1.085 0 1.519.827 1.519 2.04v4.825h2.998V11.55c0-2.77-1.479-4.06-3.451-4.06zM4.599 3.353c-1.026 0-1.696.673-1.696 1.559 0 .866.65 1.558 1.657 1.558h.019c1.046 0 1.696-.693 1.696-1.558-.02-.885-.651-1.559-1.676-1.559z" />
                    </svg>
                  </div>
                  <div className="w-embed">
                    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="currentColor" fillRule="evenodd">
                      <path fillRule="nonzero" d="M13.906 0H6.15C3 0 .528 2.706.528 6v8c0 3.294 2.473 6 5.62 6h7.757c3.036 0 5.62-2.706 5.62-6V6c0-3.294-2.586-6-5.62-6zm3.7 14c0 2.235-1.686 4-3.7 4H6.15c-2.024 0-3.7-1.765-3.7-4V6c0-2.235 1.686-4 3.7-4h7.757c2.024 0 3.7 1.765 3.7 4v8zM9.972 4.824c-2.698 0-4.947 2.353-4.947 5.176s2.25 5.176 4.947 5.176S14.92 12.823 14.92 10s-2.25-5.176-4.947-5.176zm0 8.353c-1.686 0-3.036-1.412-3.036-3.176s1.35-3.176 3.036-3.176 3.035 1.4 3.035 3.175-1.35 3.176-3.036 3.176z" />
                      <ellipse cx="14.75" cy="4.824" rx="1.222" ry="1.294" />
                    </svg>
                  </div>
                  <div className="w-embed">
                    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20}>
                      <path fill="currentColor" fillRule="evenodd" d="M10.152.205C5.076.205.879 4.51.879 9.943c0 4.1 2.44 7.687 5.955 9.02-.098-.717-.195-1.947 0-2.767.195-.718 1.074-4.818 1.074-4.818s-.293-.615-.293-1.435c0-1.333.781-2.358 1.66-2.358s1.171.615 1.171 1.333c0 .82-.488 2.05-.683 3.28-.293.922.39 1.742 1.367 1.742 1.66 0 2.929-1.845 2.929-4.51 0-2.255-1.66-3.895-3.905-3.895-2.636 0-4.198 2.05-4.198 4.203 0 .82.293 1.742.683 2.255.098.103.098.103.098.205-.098.308-.293 1.025-.293 1.127 0 .205-.098.205-.293.103-1.171-.513-1.855-2.255-1.855-3.69 0-3.075 2.05-5.945 6.052-5.945 3.221 0 5.76 2.46 5.76 5.637 0 3.383-2.05 6.047-4.783 6.047-.976 0-1.855-.512-2.148-1.127l-.586 2.358c-.195.82-.781 1.845-1.171 2.563.879.205 1.757.41 2.733.41 5.174 0 9.274-4.407 9.274-9.737 0-5.433-4.1-9.737-9.274-9.737" />
                    </svg>
                  </div>
                  <div className="w-embed">
                    <svg xmlns="http://www.w3.org/2000/svg" width={25} height={20}>
                      <path fill="currentColor" d="M10.056 13.437V6.48l6.64 3.478-6.64 3.478zM24.68 5.295s-.237-1.74-.95-2.45c-.95-1.028-1.976-1.028-2.45-1.107L12.586 1.5l-8.617.237c-.474.08-1.58.08-2.45 1.107C.727 3.555.5 5.295.5 5.295S.253 7.27.253 9.247v1.897c0 1.976.237 3.953.237 3.953s.237 1.74 1.028 2.53c.87.95 2.134.95 2.688 1.028 1.976.158 8.38.237 8.38.237l8.696-.237c.474-.08 1.502-.08 2.45-1.028.71-.79.95-2.53.95-2.53s.316-1.976.316-3.953V9.247c0-1.976-.316-3.953-.316-3.953h0z" />
                    </svg>
                  </div>
                  <div className="w-embed">
                    <svg xmlns="http://www.w3.org/2000/svg" width={18} height={20}>
                      <path fill="currentColor" d="M4 0L.429 3.571v12.857h4.286V20l3.571-3.571h2.857L17.572 10V0H4zm12.143 9.286l-2.857 2.857h-2.857l-2.5 2.5v-2.5H4.715V1.429h11.429v7.857zm-3.571-5.357h1.429v4.286h-1.429zm-3.929 0h1.429v4.286H8.643z" />
                    </svg>
                  </div>
                </div>
                <div className="x_contact_f">
                  <div>
                    <a target="_blank" href="https://www.gnomon.edu/academics/foundation-in-art-and-design/" className="x_footer_link_li">Terms of Use</a>
                  </div>
                  <div>
                    <a target="_blank" href="https://www.gnomon.edu/academics/foundation-in-art-and-design/" className="x_footer_link_li">Privacy Policy</a>
                  </div>
                </div>
              </div>
            </div>
            <div className="x_footer_right">
              <div className="x_footer_right_cols">
                <div className="x_footer_nav">
                  <div className="x_footer_links">
                    <div className="x_footer_link_li">
                      <div>
                        <a target="_blank" href="https://www.gnomon.edu/academics/foundation-in-art-and-design/" className="x_footer_link_li">© Gnomon 1997 – 2025 — All rights reserved.</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}